import apiRequest from "../../functions/api";
import umlauteErsetzen from "../shared/functions/umlauteErsetzen";

export const uploadFile = (client, accessToken, file, hdokKey, hvktKey, gueltigAb, gueltigBis) => {
  return new Promise((resolve, reject) => {
    const headers = {
      Authorization: "Bearer " + accessToken,
      Mandant: client, // this.props.client,
      program: hvktKey ? "WEBAGU" : "LTERW2",

      Statement: "DATEI_HOCHLADEN",
    };
    const payload = {
      hdokKey,
      hvktKey: hvktKey.substring(3),
      aufgabe: hvktKey.substring(3),
      aufgabeVon: hvktKey.substring(0, 3),
      gueltigAb,
      gueltigBis,
      FileName: umlauteErsetzen(file.name),
    };

    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    file.map((einzelnesFile) => {
      console.log(einzelnesFile)
      formData.append("file", einzelnesFile, einzelnesFile.name);
    });

    apiRequest(
      "POST",
      "upload",
      formData,
      headers,
      (response) => {
        if (response.status === 200 && response.data.message === "ok") {
          const id = response.data.belege.allKeys[0];
          resolve(response.data.belege.byKey[id]);
        } else {
          if (response) {
            reject(response.data.message);
          } else {
            reject("Keine Internetverbindung");
          }
        }
        resolve();
      },
      () => {
        reject("Es ist ein Fehler aufgetreten. Bitte versuchen Sie den Upload erneut.");
      }
    );
  });
};
